
/* announcement-bar */
class AnnouncementBarCarousel extends HTMLElement {
  constructor() {
    super();
    this.slides = [];
    this.currentIndex = 0;
    this.interval = null;
    this.cycleSpeed = 5000;
    this.autoplayEnabled = false;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll("p"));
    this.currentIndex = 0;

    const autoplayAttr = this.getAttribute("autoplay");
    this.autoplayEnabled = autoplayAttr !== null;
    if (this.autoplayEnabled && !isNaN(parseInt(autoplayAttr))) {
      this.cycleSpeed = parseInt(autoplayAttr) * 1000;
    }

    if (this.slides.length <= 1) return;

    // Set container styles for proper positioning
    this.style.position = "relative";
    this.style.overflow = "hidden";
    this.style.minHeight = "1em";

    // Style all slides and set is-selected only for the first
    this.slides.forEach((slide, index) => {
      slide.style.transition = "opacity 0.4s ease, transform 0.4s ease";
      slide.style.position = "absolute";
      slide.style.top = "0";
      slide.style.left = "0";
      slide.style.right = "0";
      slide.style.opacity = index === 0 ? "1" : "0";
      slide.style.transform = index === 0 ? "translateY(0)" : "translateY(100%)";
      slide.style.pointerEvents = index === 0 ? "auto" : "none";
      if (index === 0) {
        slide.classList.add("is-selected");
      } else {
        slide.classList.remove("is-selected");
      }
    });

    // Wait a tick to ensure DOM is ready
    requestAnimationFrame(() => {
      const id = this.id;
      if (!id) return;

      const prevButton = document.querySelector(`carousel-prev-button[aria-controls="${id}"] button`);
      const nextButton = document.querySelector(`carousel-next-button[aria-controls="${id}"] button`);

      if (prevButton) {
        prevButton.addEventListener("click", () => this.goToSlide(this.currentIndex - 1));
      }

      if (nextButton) {
        nextButton.addEventListener("click", () => this.goToSlide(this.currentIndex + 1));
      }
    });

    if (this.autoplayEnabled) {
      this.startAutoplay();
    }
  }

  startAutoplay() {
    this.interval = setInterval(() => this.goToSlide(this.currentIndex + 1), this.cycleSpeed);
  }

  stopAutoplay() {
    clearInterval(this.interval);
    this.interval = null;
  }

  goToSlide(newIndex) {
    if (this.slides.length < 2) return;

    this.stopAutoplay();

    const prev = this.slides[this.currentIndex];
    this.currentIndex = (newIndex + this.slides.length) % this.slides.length;
    const next = this.slides[this.currentIndex];

    // First, position the next slide below the viewport without transition
    next.style.transition = "none";
    next.style.opacity = "1";
    next.style.transform = "translateY(100%)";
    next.style.pointerEvents = "auto";
    next.classList.add("is-selected");

    // Force a reflow to ensure the initial position is applied
    next.offsetHeight;

    // Now start the transitions
    next.style.transition = "opacity 0.4s ease, transform 0.4s ease";
    
    // Move previous slide up and hide it
    prev.style.opacity = "0";
    prev.style.transform = "translateY(-100%)";
    prev.style.pointerEvents = "none";
    prev.classList.remove("is-selected");
    
    // Move next slide from below to center
    next.style.transform = "translateY(0)";

    if (this.autoplayEnabled) {
      this.startAutoplay();
    }
  }
}

if (!window.customElements.get("announcement-bar-carousel")) {
  window.customElements.define("announcement-bar-carousel", AnnouncementBarCarousel);
}
